export enum SchemaApiErrorTypes {
  CreateSchemaProjectError,
  CreateSchemaProjectConflictError,
  DeleteSchemaProjectError,
  LoadSchemaProjectsError,
  LoadSchemasError,
  LoadSchemaDefinitionsError,
  LoadSchemaDefinitionVersionsError,
  LoadSchemaDefinitionError,
  CreateSchemaDefinitionError,
  DeleteSchemaDefinitionError,
  SchemaProjectNotFoundError,
  SchemaNotFoundError,
  CreateSchemaError,
}

export class SchemaApiError {
  constructor(public type: SchemaApiErrorTypes, public error: Error) {}
}
